import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Loader } from "@googlemaps/js-api-loader"
import { environment } from 'src/environments/environment';
import { BusinessDataService } from 'src/app/business/services/data.service';
import { getDistance } from 'geolib';
const loader = new Loader({
  apiKey: environment.gmap,
  version: "weekly",
});

loader.load().then(async () => {
  const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
});
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnChanges {
  latitude: number;
  longitude: number;
  zoom: number;
  apiLoaded: Observable<boolean>;
  address: string;
  private geoCoder;
  loading = true;
  options: google.maps.MapOptions;
  @Input() locations: any = [];
  @Input() loggedIn: boolean = false;
  @ViewChild('mapElement', {static: false}) mapElement: ElementRef;
  map: google.maps.Map;
  center;
  @Input('location') location: string = '';
  @Input('context') context = '';
  @Output('distancesFromCurrentPosition') distancesFromCurrentPosition: EventEmitter<any> = new EventEmitter(null);
  currentLocation;
  mapOptions: google.maps.MapOptions;
  infoWindow: google.maps.InfoWindow;
  directionsService;
  directionsRenderer: google.maps.DirectionsRenderer;
  mapMarkers = [];
  business;
  constructor(private httpClient: HttpClient) {
    this.geoCoder = new google.maps.Geocoder;
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if(changes.location){
      await this.getCurrentLocation();
    }
  }

 

  async getCurrentLocation(): Promise<void>{

    // if (navigator) {
    // navigator.geolocation.getCurrentPosition(async (position) => {
      // console.log("Current position: ", position)
      // this.getAddress(position.coords.latitude, position.coords.longitude).then(res => this.currentLocation = res)
      // if(this.loggedIn)
      //   this.drawMarker('You are here', { lat: position.coords.latitude, lng: position.coords.longitude });
    // }, (error: GeolocationPositionError) => {
    //   alert('We could not find your current location. ' + error.message);
    // });
        await this.getLatLng(this.location).then(
          res => {
            this.latitude = res.lat;
            this.longitude = res.lng
          }
        );
        this.mapOptions = {
          center: new google.maps.LatLng({ lat: this.latitude, lng: this.longitude }),
          zoom: 10
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapOptions);
        this.infoWindow = new google.maps.InfoWindow();
        this.drawMarker('We are here',{ lat: this.latitude, lng: this.longitude });
    // }
  }
  async getAddress(latitude, longitude): Promise<string> {
    let address = '';
    await this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          address = results[0].formatted_address;
        } else {
          window.alert('No results found');
          
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    });
    return address;
  }

  async getLatLng(address: string): Promise<{ lat: number, lng: number }> {
    let res;
    await this.geoCoder.geocode({ 'address': address }, (results, status) => {
        if(results){
          res = {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()}
        }else {
          res = null;
        }
    }).catch(err => console.log(err));
    return res;
  }
  svgMarker = {
    path: "M24 27C31.575 27 37.7143 20.9566 37.7143 13.5C37.7143 6.04336 31.575 0 24 0C16.425 0 10.2857 6.04336 10.2857 13.5C10.2857 20.9566 16.425 27 24 27ZM34.2643 30.4383L29.1429 50.625L25.7143 36.2812L29.1429 30.375H18.8571L22.2857 36.2812L18.8571 50.625L13.7357 30.4383C6.09643 30.7969 0 36.9457 0 44.55V48.9375C0 51.7324 2.30357 54 5.14286 54H42.8571C45.6964 54 48 51.7324 48 48.9375V44.55C48 36.9457 41.9036 30.7969 34.2643 30.4383Z",
    fill: "#000000",
    fillOpacity: 0.6,
    strokeWeight: 0,
    rotation: 0,
    scale: 0.5,
    anchor: new google.maps.Point(0, 20),
  };
  async drawMarker(text: string, location: {lat: number, lng: number}, address?: string): Promise<void> {
    let targetAddress = address ? address : '';
    let icon;
    let label;

    if(targetAddress === ''){
      targetAddress = await this.getAddress(location.lat, location.lng);
      icon = this.svgMarker;
      label = text;
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        draggable: false,
        map: this.map,
        panel: document.getElementById("panel"),
      });
    }
      const tempMarker = new google.maps.Marker({position: location, map: this.map, icon: icon, label: label});
      tempMarker.addListener('click',(() => {
      this.infoWindow.setContent('<h2><b>' + text +'</b></h2>' + '<p><b>Address</b> : ' + targetAddress +'</p>' + '<a target="_blank" href="https://www.google.com/maps/search/'+ targetAddress + '">Open in google</a>');
      this.infoWindow.open(this.map, tempMarker);
      }));
      this.mapMarkers.push(tempMarker);

      // console.log(this.directionsRenderer.getDirections())
      // const directions = this.directionsRenderer.getDirections();
      // if(directions){
      //   this.computeTotalDistance(directions)
      // }
      if(this.location.length > 5 && this.loggedIn){
      this.displayRoute(
        this.currentLocation,
        this.location,
        this.directionsService,
        this.directionsRenderer
      );
    }
      }
    
    displayRoute(
      origin: string,
      destination: string,
      service: google.maps.DirectionsService,
      display: google.maps.DirectionsRenderer
    ) {
      service.route({
          origin: origin,
          destination: destination,
          waypoints: [],
          travelMode: google.maps.TravelMode.DRIVING,
          avoidTolls: true,
        })
        .then((result: google.maps.DirectionsResult) => {
          display.setDirections(result);
        })
        .catch((e) => {
          console.log("Could not display directions due to: " + e);
        });
    }
    
    // computeTotalDistance(result: google.maps.DirectionsResult) {
    //   console.log(result)
    //   let total = 0;
    //   const myroute = result.routes[0];
    
    //   if (!myroute) {
    //     return;
    //   }
    
    //   for (let i = 0; i < myroute.legs.length; i++) {
    //     total += myroute.legs[i]!.distance!.value;
    //   }
    
    //   total = total / 1000;
    //   (document.getElementById("total") as HTMLElement).innerHTML = total + " km";
    // }

     async ngOnInit(): Promise<void> {
        if (navigator) {
          navigator.geolocation.getCurrentPosition(async (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;

          this.getAddress(position.coords.latitude, position.coords.longitude).then(res => this.currentLocation = res)

      this.mapOptions = {
          center: new google.maps.LatLng({ lat: position.coords.latitude, lng: position.coords.longitude }),
          zoom: 10
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, this.mapOptions);
        this.infoWindow = new google.maps.InfoWindow();
      // this.drawMarker('You are here', { lat: position.coords.latitude, lng: position.coords.longitude });
      
    }, (error: GeolocationPositionError) => {
      alert('We could not find your current location. ' + error.message);
    });
        //     await this.getLatLng(this.location).then(
        //   res => {
        //     console.log(res)
        //     this.latitude = res.lat;
        //     this.longitude = res.lng
        //   }
        // );
    let locationsWithDistances = [];
    for (let i of this.locations){
      const address = i.address ? i.address : i.Address;
      if(address.length > 10){
        console.log(address)
        const res = await this.getLatLng(address);
        if(res){
          const distanceFromCurrentPosition = getDistance({latitude: this.latitude, longitude: this.longitude},res);
          locationsWithDistances.push({...i, distanceFromCurrent: distanceFromCurrentPosition/1000})
          await this.drawMarker(i.Name,res, address);
        }
      }
    }
    const locationsOrderedByDistanceFrom = locationsWithDistances.sort((a, b) => a.distanceFromCurrent - b.distanceFromCurrent);
    this.distancesFromCurrentPosition.emit(locationsOrderedByDistanceFrom)
    this.loading = false;
  }
     }
}
// https://www.google.com/maps/search/-26.1743733,28.3111257/@-26.1743733,28.3085454,17z?entry=ttu